// import React, { useState, useEffect } from "react";
// import { AsyncPaginate } from "react-select-async-paginate";
// import { CaseServices } from "../../../services/CaseServices";

// export default function DocumentNameSelect({
//   onChange,
//   value,
//   isMulti = false,
// }) {
//   const [selectedOption, setSelectedOption] = useState(isMulti ? [] : null);

//   useEffect(() => {
//     if (isMulti) {
//       if (Array.isArray(value)) {
//         setSelectedOption(value.map((v) => ({ value: v, label: v })));
//       } else {
//         setSelectedOption([]);
//       }
//     } else {
//       if (value) {
//         setSelectedOption({ value, label: value });
//       } else {
//         setSelectedOption(null);
//       }
//     }
//   }, [value, isMulti]);

//   const loadDocumentNameList = async (searchKey, loadedOptions, { page }) => {
//     try {
//       const limit = 10;
//       const res = await CaseServices.getDefaultDocumentNameList(
//         searchKey || "",
//         page,
//         limit
//       );

//       const list = res?.data?.docNameData || [];
//       const hasMore = page < res?.data?.totalPages;

//       const options = list.map((item) => ({
//         value: item?.documentName,
//         label: item?.documentName,
//       }));

//       return {
//         options,
//         hasMore,
//         additional: { page: page + 1 },
//       };
//     } catch (err) {
//       console.error("Error fetching documents name:", err);
//       return {
//         options: [],
//         hasMore: false,
//         additional: { page },
//       };
//     }
//   };

//   return (
//     <AsyncPaginate
//       isMulti={isMulti}
//       isClearable
//       debounceTimeout={300}
//       additional={{ page: 1 }}
//       loadOptions={loadDocumentNameList}
//       value={selectedOption}
//       onChange={(option) => {
//         if (isMulti) {
//           const values = (option || []).map((opt) => opt.value);
//           setSelectedOption(option || []);
//           onChange(values);
//         } else {
//           setSelectedOption(option || null);
//           onChange(option?.value || "");
//         }
//       }}
//       placeholder={
//         isMulti ? "Select one or more document names" : "Select document name"
//       }
//     />
//   );
// }

import React, { useState, useEffect } from "react";
import Creatable from "react-select/creatable";
import { withAsyncPaginate } from "react-select-async-paginate";
import { CaseServices } from "../../../services/CaseServices";

const AsyncPaginateCreatable = withAsyncPaginate(Creatable);

export default function DocumentNameSelect({
  onChange,
  value,
  isMulti = false,
}) {
  const [selectedOption, setSelectedOption] = useState(isMulti ? [] : null);

  useEffect(() => {
    if (isMulti) {
      if (Array.isArray(value)) {
        setSelectedOption(
          value.map((v) => ({
            value: v,
            label: v,
          })),
        );
      } else {
        setSelectedOption([]);
      }
    } else {
      if (value) {
        setSelectedOption({
          value,
          label: value,
        });
      } else {
        setSelectedOption(null);
      }
    }
  }, [value, isMulti]);

  const loadDocumentNameList = async (searchKey, loadedOptions, { page }) => {
    try {
      const limit = 10;

      const res = await CaseServices.getDefaultDocumentNameList(
        searchKey || "",
        page,
        limit,
      );

      const list = res?.data?.docNameData || [];

      const options = list.map((item) => ({
        value: item?.documentName,
        label: item?.documentName,
      }));

      return {
        options,
        hasMore: page < res?.data?.totalPages,
        additional: {
          page: page + 1,
        },
      };
    } catch (err) {
      console.error("Error fetching documents name:", err);

      return {
        options: [],
        hasMore: false,
        additional: { page },
      };
    }
  };

  const handleChange = async (option) => {
    if (isMulti) {
      const values = (option || []).map((opt) => opt.value);

      setSelectedOption(option || []);
      onChange(values);
    } else {
      setSelectedOption(option || null);
      onChange(option?.value || "");
    }

    // Optional:
    // Save newly created document names
    const newOptions = Array.isArray(option)
      ? option.filter((opt) => opt.__isNew__)
      : option?.__isNew__
        ? [option]
        : [];

    if (newOptions.length) {
      try {
        await Promise.all(
          newOptions.map((opt) =>
            CaseServices.createDocumentName({
              documentName: opt.value,
            }),
          ),
        );
      } catch (error) {
        console.error("Failed to create document name", error);
      }
    }
  };

  return (
    <AsyncPaginateCreatable
      isMulti={isMulti}
      isClearable
      debounceTimeout={300}
      additional={{ page: 1 }}
      loadOptions={loadDocumentNameList}
      value={selectedOption}
      onChange={handleChange}
      formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
      isValidNewOption={(inputValue, _, selectOptions) =>
        inputValue.trim() &&
        !selectOptions.some(
          (option) => option.label.toLowerCase() === inputValue.toLowerCase(),
        )
      }
      placeholder={
        isMulti
          ? "Select or create document names"
          : "Select or create document name"
      }
    />
  );
}
